import { combineReducers } from 'redux'

/*********
  전자계약
**********/

import contracterReducer from './contract/contracter.reducer'
import contractReducer from './contract/contract.reducer'

/*********
  모듈
**********/

import alertReducer from './alert/alert.reducer'
import paginationReducer from './pagination.reducer'
import loaderReducer from './loader/loader.reducer'
import inputReducer from './input.reducer'

/*********
  회원
**********/

import certificateReducer from './certificate/certificate.reducer'
import authReducer from './auth/auth.reducer'
import regisReducer from './regis/regis.reducer'
import userinfoReducer from './userinfo/userinfo.reducer'

/*********
 사업자관리
 **********/
import manageReducer from './manage/manage.reducer'

/*********
  채팅
**********/

import chatReducer from './chat.reducer'

/*********
 고객지원
 **********/
import referenceReducer from './reference/reference.reducer'
import noticeReducer from './notice/notice.reducer'
import faqReducer from './faq/faq.reducer'
import questReducer from './question/question.reducer'

/*********
 서비스
 **********/
import inboxReducer from './inbox/inbox.reducer'
import certboxReducer from './certbox/certbox.reducer'
import sentReducer from './sent/sent.reducer'
import verifyReducer from './verify/verify.reducer'
import certmngReducer from './certmng/certmng.reducer'
import certissueReducer from './certissue/certissue.reducer'
import bundleReducer from './bundle/bundle.reducer'
import certapplyReducer from './certapply/certapply.reducer'
import efdocReducer from './efdoc/efdoc.reducer'
import chempCertboxReducer from './chemp/chempCertbox.reducer'
import chempSendboxReducer from './chemp/chempSendbox.reducer'

/*********
 공통
 **********/

import commonReducer from './common.reducer'
import listReducer from './list/list.reducer'
import commoncodeReducer from './common/commoncode.reducer'

/**********
 모바일
 **********/

import mobileReducer from './mobile/mobile.reducer'

import modalReducer from './modal/modal.reducer'

import termsReducer from './etc/terms.reducer'
import privacyReducer from './etc/privacy.reducer'
import settingReducer from './home/setting.reducer'

/**
 * 전자문서지갑
 */
import govcertapplyReducer from './gov/certapply/gov.certapply.reducer'

const rootReducer = combineReducers({
  /*********
    전자계약
  **********/

  contracter: contracterReducer,
  contract: contractReducer,

  /*********
    모듈
  **********/

  alert: alertReducer,
  pagination: paginationReducer,
  loader: loaderReducer,
  input: inputReducer,

  /*********
    회원
  **********/

  auth: authReducer,
  regis: regisReducer,
  certificate: certificateReducer,
  userinfo: userinfoReducer,

  /*********
   사업자관리
   **********/
  manage: manageReducer,

  /*********
    채팅
  **********/

  chat: chatReducer,

  /*********
   고객지원
   **********/
  reference: referenceReducer,
  notice: noticeReducer,
  faq: faqReducer,
  quest: questReducer,

  /*********
   서비스
   **********/
  inbox: inboxReducer,
  certbox: certboxReducer,
  sent: sentReducer,
  verify: verifyReducer,
  certmng: certmngReducer,
  certissue: certissueReducer,
  bundle: bundleReducer,
  certapply: certapplyReducer,
  efdoc: efdocReducer,
  chempCertbox: chempCertboxReducer,
  chempSendbox: chempSendboxReducer,

  /*********
   공통
   **********/
  // commoncode: commoncodeReducer,
  common: commonReducer,
  list: listReducer,
  commoncode: commoncodeReducer,

  /********
   모바일
   ********/

  mobile: mobileReducer,

  /********
   모달 :레이어팝업
   ********/
  modal: modalReducer,

  /**
   * 이용약관
   */
  terms: termsReducer,
  /**
   * 개인정보처리방침
   */
  privacy: privacyReducer,

  /**
   * 전자문서지갑
   */
  govcertapply: govcertapplyReducer,

  /**
   * 모바일 setting 자동로그인 설정
   */
   setting: settingReducer,

})

export default rootReducer
